<template>
  <div class="main_tak">
    <!-- 作业详情 -->
    <el-card class="task_info" header="作业内容" shadow="hover">
      <div class="lrlist">
        <template v-if="list.chapter_id > 0">
          <div class="item">
            <div class="l">课&emsp;&emsp;程：</div>
            <div class="r">{{ list.course_name }}</div>
          </div>
          <div class="item">
            <div class="l">小&emsp;&emsp;节：</div>
            <div class="r">{{ list.chapter_title }}</div>
          </div>
        </template>
        <template v-else>
          <div class="item">
            <div class="l">课&emsp;&emsp;程：</div>
            <div class="r">课外作业</div>
          </div>
        </template>
        <div class="item">
          <div class="l">作业备注：</div>
          <div class="r">{{ list.introduction }}</div>
        </div>
        <div class="item">
          <div class="l">作业图片：</div>
          <div class="r workImgs">
            <el-image
              v-for="(item, index) in list.works"
              :key="index"
              fit="cover"
              :preview-src-list="srcList"
              :src="item.src"
            />
          </div>
        </div>
      </div>
      <div class="create_time">
        <span> 提交于 {{ list.create_time }}</span>
      </div>
    </el-card>
    <!-- 老师评价 -->
    <el-card class="teacher_info" header="老师点评" shadow="hover">
      <div v-if="list.teacher_id > 0" class="card_box">
        <div class="top">
          <div class="teacher_name">
            <img class="head" :src="list.teacher_head" />
            <div class="info">
              <span>{{ list.teacher_name }}</span>
              <span v-if="list.comment_status == 0" class="time">{{
                list.teacher_time
              }}</span>
              <span v-if="list.comment_status == 1" class="time">{{
                list.comment_time
              }}</span>
              <span
                v-if="list.comment_status == 2 && list.reject_time"
                class="time"
                >{{ list.reject_time }}</span
              >
            </div>
          </div>

          <div class="status">
            <div v-if="list.comment_status == 0">
              <span class="wait">待评价</span>
            </div>
            <div v-if="list.comment_status == 1">
              <span class="score"> {{ list.comment_score }}</span>
            </div>
            <div v-if="list.comment_status == 2" class="reject">
              <icon-svg fill="#ff8b8b" icon-class="bohui" />
            </div>
          </div>
        </div>

        <div v-if="list.comment_status === 1" class="lrlist">
          <div class="item">
            <div class="l">点评内容：</div>
            <div class="r">{{ list.comment_content || '无' }}</div>
          </div>
          <div v-if="list.comment_file.length > 0" class="item">
            <div class="l">点评图片：</div>
            <div class="r workImgs">
              <el-image
                v-for="(item, index) in list.comment_file"
                :key="index"
                fit="cover"
                :preview-src-list="srcList"
                :src="item.src"
              />
            </div>
          </div>
        </div>
        <div v-if="list.comment_status === 2" class="lrlist">
          <div class="item">
            <div class="l">驳回原因：</div>
            <div class="r">{{ list.reject_content || '无' }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="color: #828282; text-align: center">
          请耐心等待老师点评...
        </div>
      </div>
    </el-card>
    <!-- 评价内容 -->
    <el-card
      v-if="list.comment_status === 1"
      class="comment_content"
      shadow="hover"
    >
      <!-- 用户打分 -->
      <div class="user_evaluation">
        <div>
          <div class="text">老师的点评是否满意，为老师打个分吧~</div>
          <el-rate
            v-model="list.user_evaluation_score"
            :colors="colors"
            :disabled="list.user_evaluation_status == 1"
          />
        </div>
        <el-button
          :disabled="list.user_evaluation_status == 1"
          plain
          size="small"
          type="primary"
          @click="userEvaluation"
        >
          <span v-if="list.user_evaluation_status == 1">已打分</span>
          <span v-else>提交打分</span>
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getWorkDetails, setUserEvaluation } from '@/api/task'
export default {
  data() {
    return {
      list: {
        introduction: '',
        teacher_head: '',
        teacher_time: '',
      },
      value: null,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      iconClasses: ['icon-rate-face-1', 'icon-rate-face-2', 'icon-rate-face-3'],
      srcList: [],
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
  },
  mounted() {},
  created() {
    this.getWorkDetails()
  },
  methods: {
    async getWorkDetails() {
      const {
        data: { result },
      } = await getWorkDetails({ id: this.id })
      this.list = result
      console.log(this.list)
      result.works.map((el) => {
        this.srcList.push(el.src)
      })
    },
    userEvaluation() {
      console.log(this.list.id + '-' + this.list.user_evaluation_score)
      if (this.list.user_evaluation_score === 0) {
        this.$message('请先打分')
      }

      //打分完成要重新获取list更新打分状态
      setUserEvaluation({
        id: this.list.id,
        score: this.list.user_evaluation_score,
      }).then(
        (res) => {
          const code = res.data.code
          if (code == 0) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
            this.getWorkDetails()
          }
        },
        (err) => {
          console.log(err)
        }
      )
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-rate__icon {
  font-size: 25px;
  margin-right: 10px;
}

.lrlist {
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding: 0 0;
    margin-bottom: 14px;
    line-height: 26px;
    .l {
      flex-shrink: 0;
      width: 90px;
      font-size: 15px;
      color: #828282;
      text-align: left;
      margin-right: 10px;
    }
    .r {
      flex: 1;
      font-size: 16px;
    }
  }
  .workImgs {
    display: inline-flex;
    flex-wrap: wrap;
    .el-image {
      width: 100px;
      height: 100px;
      margin-right: 8px;
      margin-bottom: 8px;
      border-radius: 2px;
      border: 1px solid #f8f8fa;
    }
  }
}
.main_tak {
  display: flex;
  width: 960px;
  margin: 0 auto;
  padding: 30px 20px 30px 20px;
  min-height: calc(100vh - 67px - 112px);
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .task_info {
    width: 100%;

    .create_time {
      text-align: right;
      span {
        font-size: 15px;
        color: #828282;
      }
    }
  }
  .teacher_info {
    margin-top: 20px;
    width: 100%;
    .card_box {
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .teacher_name {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .head {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            border: 2px solid #c0baba42;
            margin-right: 10px;
          }
          .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            span {
              font-size: 16px;
              color: #828282;
              line-height: 1.8;
              &.time {
                font-size: 14px;
              }
            }
          }
        }
        .status {
          padding: 0 0;
          .reject {
            font-size: 68px;
          }
          .wait {
            border: 2px solid #828282;
            border-radius: 5px;
            padding: 2px 7px;
            font-size: 20px;
            font-weight: 600;
            color: #828282;
          }
          .score {
            font-size: 30px;
            font-weight: 800;
            color: rgb(8, 183, 60);
          }
          img {
            width: 70px;
            height: 70px;
          }
        }
      }

      .reject_reson {
        width: 100%;
        margin-top: 30px;
        span {
          font-size: 15px;
          color: rgb(38, 36, 36);
        }
      }
    }
  }
  // 作业点评
  .comment_content {
    margin-top: 20px;
    width: 100%;
    .content {
      padding: 10px 20px;
      white-space: pre-line;
    }

    //用户打分
    .user_evaluation {
      padding: 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text {
        font-size: 14px;
        margin-bottom: 10px;
      }
      .el-button {
        margin-left: 40px;
      }
    }
  }
}
</style>
